// Version courante des documents juridiques publiés (CGU + Politique de confidentialité).
// Cette chaîne est stockée dans `profiles.terms_version` au moment de l'inscription
// pour conserver la trace de la version exacte acceptée par l'utilisateur.
//
// Format recommandé : `YYYY-MM-DD` aligné sur la date de dernière mise à jour
// affichée en en-tête de PrivacyPolicy.tsx et TermsOfService.tsx. Tout changement
// substantiel d'un de ces documents doit incrémenter cette constante.
//
// Lorsque la version change, il faut prévoir une notification in-app pour les
// utilisateurs existants afin de recueillir une nouvelle acceptation.

export const LEGAL_VERSION = '2026-06-03';
